import React from 'react';
import './LoadingOverlay.css';

/**
 * Reusable component for displaying a loading overlay
 *
 * @param root0
 * @param root0.message Optional message to display
 */
export function LoadingOverlay({
	message = null,
}: {
	message?: string | null;
}) {
	return (
		<div className="inventory-loading-overlay">
			<div className="inventory-loading-overlay-content">
				<i className="gform-spinner gform-spinner--active"></i>
				{message}
			</div>
		</div>
	);
}
